import '@connectedhomes/nucleus/nucleus.min.js';
import { hijackEffects } from 'stop-runaway-react-effects';
import { v4 as uuidv4 } from 'uuid';

import { initDataDogRUM } from 'analytics/initDataDogRUM';
import { initPartner } from 'components/app/initPartner';
import { STORAGE, sessionStorageKeys } from 'config/storage-config';

const { NODE_ENV, VITE_AWS_WAF_DOMAINS } = import.meta.env;

/* istanbul ignore next -- @preserve */
if (window.self !== window.top) {
  throw new Error('Embedding in an iframe is not allowed.');
}

if (NODE_ENV !== 'production') {
  hijackEffects();
}

window.awsWafCookieDomainList = VITE_AWS_WAF_DOMAINS.split(',');

const currentSession = STORAGE.getItem(sessionStorageKeys.SESSION);

!currentSession && STORAGE.setItem(sessionStorageKeys.SESSION, uuidv4(), false);

STORAGE.removeItem(sessionStorageKeys.STATE);

initPartner();
initDataDogRUM();

document.body.classList.add('ndsn'); // add nucleus namespace ...
